export const EMAIL_UPDATE_SUCCESS_IN = 'Email update successful in:';
export const EMAIL_UPDATE_FAILED_IN = 'Email update failed in:';
export const EMAIL_UPDATE_ERROR = 'An error has occured while updating the email;';



// WEBPACK FOOTER //
// ./src/constants/response-messages.js